<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-channelSwitchHistory">
      <!-- 从订单页面跳转的提示 -->
      <el-alert
        v-if="$route.query.orderCode"
        title="已自动筛选"
        :description="`正在查看订单 ${$route.query.orderCode} 的通道切换历史`"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 15px;">
      </el-alert>

      <!-- 查询表单 -->
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.orderCode" placeholder="订单号" clearable style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.merchantType" placeholder="商户类型" clearable filterable style="width: 180px;">
            <el-option
              v-for="item in merchantTypeArray"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isSuccess" placeholder="成功状态" clearable style="width: 150px;">
            <el-option label="成功" :value="1"></el-option>
            <el-option label="失败" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getDataList()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%;">
        <el-table-column prop="id" label="ID" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="orderCode" label="订单号" header-align="center" align="center" width="320"></el-table-column>
        <el-table-column prop="merchantTypeName" label="商户类型" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="peyTypeName" label="支付类型" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="isSuccess" label="成功状态" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isSuccess === 1 ? 'success' : 'danger'">
              {{ scope.row.successText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" label="响应时间" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.responseTime > 2000 ? '#F56C6C' : '' }">
              {{ scope.row.responseTime }}ms
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="attemptOrder" label="尝试顺序" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            第{{ scope.row.attemptOrder }}次
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center" width="250"></el-table-column>
        <el-table-column label="操作" fixed="right"   header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showResponseData(scope.row)">查看响应</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
        style="margin-top: 20px;">
      </el-pagination>

      <!-- 响应数据弹窗 -->
      <el-dialog
        title="响应数据详情"
        :visible.sync="responseDialogVisible"
        width="600px">
        <div v-if="currentResponseData">
          <el-descriptions :column="2" border>
            <el-descriptions-item label="订单号">{{ currentRow.orderCode }}</el-descriptions-item>
            <el-descriptions-item label="商户类型">{{ currentRow.merchantTypeName }}</el-descriptions-item>
            <el-descriptions-item label="支付类型">{{ currentRow.peyTypeName }}</el-descriptions-item>
            <el-descriptions-item label="成功状态">
              <el-tag :type="currentRow.isSuccess === 1 ? 'success' : 'danger'">
                {{ currentRow.successText }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="响应时间">{{ currentRow.responseTime }}ms</el-descriptions-item>
            <el-descriptions-item label="尝试顺序">第{{ currentRow.attemptOrder }}次</el-descriptions-item>
          </el-descriptions>

          <el-divider>响应数据</el-divider>

          <pre style="background-color: #f5f7fa; padding: 15px; border-radius: 4px; max-height: 400px; overflow-y: auto;">{{ formatJson(currentResponseData) }}</pre>
        </div>
        <div slot="footer">
          <el-button @click="responseDialogVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import { getChannelSwitchHistoryPage } from '@/api/channelSwitchHistory'

export default {
  name: 'ChannelSwitchHistory',
  data() {
    return {
      dataForm: {
        orderCode: '',
        merchantType: '',
        isSuccess: ''
      },
      dataList: [],
      page: 1,
      limit: 10,
      total: 0,
      dataListLoading: false,

      // 商户类型选项（将从后端动态加载）
      merchantTypeArray: [],

      // 响应数据弹窗
      responseDialogVisible: false,
      currentRow: {},
      currentResponseData: ''
    }
  },
  watch: {
    // 监听路由参数中的 orderCode 变化
    '$route.query.orderCode': {
      handler(newOrderCode, oldOrderCode) {
        if (newOrderCode !== oldOrderCode) {
          console.log('路由参数 orderCode 变化:', { 旧值: oldOrderCode, 新值: newOrderCode })

          // 更新表单中的订单号
          this.dataForm.orderCode = newOrderCode || ''

          // 重置到第一页
          this.page = 1

          // 自动重新查询
          this.getDataList()
        }
      },
      immediate: false // 不立即执行，避免与 created 重复查询
    }
  },
  created() {
    // 从路由参数中获取订单号（从订单页面跳转过来时）
    if (this.$route.query.orderCode) {
      this.dataForm.orderCode = this.$route.query.orderCode
      console.log('从订单页面跳转，订单号:', this.dataForm.orderCode)
    }

    // 加载支付平台配置
    this.getPaymentPlatforms()

    // 自动触发查询（如果有订单号则会自动筛选）
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true

      const params = {
        page: this.page,
        limit: this.limit,
        order: 'desc',
        orderField: 'create_time'
      }

      // 添加查询条件
      if (this.dataForm.orderCode) {
        params.orderCode = this.dataForm.orderCode
        console.log('查询参数包含订单号:', params.orderCode)
      }
      if (this.dataForm.merchantType) {
        params.merchantType = this.dataForm.merchantType
      }
      if (this.dataForm.isSuccess !== '') {
        params.isSuccess = this.dataForm.isSuccess
      }

      console.log('发送查询请求，参数:', params)

      getChannelSwitchHistoryPage(params).then(({ data: res }) => {
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }

        this.dataList = res.data.list || []
        this.total = res.data.total || 0
      }).catch(error => {
        console.error('查询通道切换历史失败:', error)
        this.$message.error('查询失败，请稍后重试')
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 获取支付平台配置（动态加载商户类型选项）
    getPaymentPlatforms() {
      this.$http.get('/payOrder/payorder/paymentPlatforms').then(({ data: res }) => {
        if (res.code === 0 && res.data.merchantTypes && res.data.merchantTypes.length > 0) {
          this.merchantTypeArray = res.data.merchantTypes.map(item => ({
            value: item.merchantType,
            label: item.merchantsName
          }))
        }
      }).catch(error => {
        console.error('获取支付平台配置失败:', error)
      })
    },

    // 重置表单
    resetForm() {
      this.dataForm = {
        orderCode: '',
        merchantType: '',
        isSuccess: ''
      }
      this.page = 1
      this.getDataList()
    },

    // 每页数
    pageSizeChangeHandle(val) {
      this.limit = val
      this.page = 1
      this.getDataList()
    },

    // 当前页
    pageCurrentChangeHandle(val) {
      this.page = val
      this.getDataList()
    },

    // 查看响应数据
    showResponseData(row) {
      this.currentRow = row
      this.currentResponseData = row.responseData
      this.responseDialogVisible = true
    },

    // 格式化JSON
    formatJson(jsonStr) {
      try {
        const obj = JSON.parse(jsonStr)
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return jsonStr
      }
    }
  }
}
</script>

<style scoped>
.mod-channelSwitchHistory {
  padding: 0;
}
</style>
